import React from 'react'
import i18n from 'i18n'
import { Input } from 'antd'
import styles from './style.module.scss'
import noteIcon from 'assets/images/calendar/note-icon.svg'

interface DescriptionSelectorProps {
  value: string
  onChange: (value: string) => void
}

const DescriptionSelector: React.FC<DescriptionSelectorProps> = ({ value, onChange }) => {
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onChange(e.target.value)
  }

  return (
    <div className={styles.descriptionSelector}>
      <div className={styles.titleIconWrapper}>
        <img src={noteIcon} alt="Notes" className={styles.titleIcon} />
      </div>
      <div className={styles.textareaWrapper}>
        <Input.TextArea
          className={styles.textarea}
          placeholder={i18n.t('todo.editor.addDescription')}
          value={value}
          onChange={handleChange}
          autoSize={{ minRows: 3, maxRows: undefined }}
        />
      </div>
    </div>
  )
}

export default DescriptionSelector
